import httpClient from './httpClient'

export default {
  async generateExternalSourceVideoId(url, source, metadata) {
    const postObj = {
      url,
      source,
    }

    if (Object.keys(metadata).length) postObj['metadata'] = metadata

    let ret = await httpClient.post('videos/external_source', postObj)
    return ret
  },
  async storeExternalSourceVideo(title, id, folder_id) {
    const storeObject = {
      title,
      video_external_source_id: id,
      status: 'CONVERTED',
    }
    if (folder_id) storeObject['folder_id'] = folder_id
    let ret = await httpClient.post('videos', storeObject)
    return ret
  },
  async createExternalSourceVideo(
    url,
    source,
    folderId = false,
    metadata = []
  ) {
    if (metadata[0] && metadata[1]) {
      metadata = {
        access_key: metadata[0],
        secret_key: metadata[1],
      }
    } else {
      metadata = {}
    }

    const { data: generatedData } = await this.generateExternalSourceVideoId(
      url,
      source,
      metadata
    )

    const { data: storedData } = await this.storeExternalSourceVideo(
      url,
      generatedData.id,
      folderId
    )
    return { ...generatedData, ...storedData }
  },
}
